var ContextMenuIconName = function() {

};

ContextMenuIconName.save_existed_report = 'saveExistedReportIcon';

ContextMenuIconName.save_new_report = 'saveNewReportIcon';

ContextMenuIconName.save = 'saveIcon';

ContextMenuIconName.add = 'addIcon';

ContextMenuIconName.refresh_all = 'refreshAllIcon';

ContextMenuIconName.reset_all = 'resetAllIcon';

ContextMenuIconName.add_punch = 'addPunchIcon';
ContextMenuIconName.add_absence = 'addAbsenceIcon';

ContextMenuIconName.add_company = 'addCompanyIcon';

ContextMenuIconName.view = 'viewIcon';

ContextMenuIconName.view_html = 'viewHTMLIcon';

ContextMenuIconName.view_html_new_window = 'viewHTMLNewWindow';

ContextMenuIconName.send = 'sendIcon';

ContextMenuIconName.decline = 'declineIcon';

ContextMenuIconName.request = 'requestIcon';

ContextMenuIconName.authorization_request = 'authorizationRequestIcon';

ContextMenuIconName.authorization_timesheet = 'authorizationTimesheetIcon';

ContextMenuIconName.authorization_expense = 'authorizationExpenseIcon';

ContextMenuIconName.pass = 'passIcon';

ContextMenuIconName.inbox = 'inboxIcon';

ContextMenuIconName.sent = 'sentIcon';

ContextMenuIconName.check_updates = 'checkUpdatesIcon';

ContextMenuIconName.export_excel = 'exportExcelIcon';

ContextMenuIconName.export_export = 'exportExportlIcon';

ContextMenuIconName.edit = 'editIcon';
ContextMenuIconName.delete_icon = 'deleteIcon';
ContextMenuIconName.delete_data = 'deleteDataIcon';
ContextMenuIconName.delete_and_next = 'deleteAndNextIcon';
ContextMenuIconName.save_and_next = 'saveAndNextIcon';
ContextMenuIconName.save_and_continue = 'saveAndContinueIcon';
ContextMenuIconName.save_and_new = 'saveAndNewIcon';
ContextMenuIconName.save_and_copy = 'saveAndCopyIcon';
ContextMenuIconName.cancel = 'cancelIcon';

ContextMenuIconName.share_report = 'shareReportIcon';

ContextMenuIconName.close_misc = 'closeIcon';

ContextMenuIconName.copy_as_new = 'copyAsNewIcon';

ContextMenuIconName.copy = 'copyIcon';

ContextMenuIconName.reply = 'replyIcon';

ContextMenuIconName.drag_copy = 'dragCopyIcon';

ContextMenuIconName.swap = 'swapIcon';

ContextMenuIconName.mass_edit = 'massEditIcon';

ContextMenuIconName.view_detail = 'viewDetailIcon';

ContextMenuIconName.download = 'downloadIcon';

ContextMenuIconName.timesheet = 'timesheetIcon';

ContextMenuIconName.in_out = 'inOutIcon';

ContextMenuIconName.accumulated_time = 'accumulatedTimeIcon';

ContextMenuIconName.import_icon = 'importIcon';

ContextMenuIconName.login = 'loginIcon';

ContextMenuIconName.permission_wizard = 'permissionWizardIcon';

ContextMenuIconName.job_invoice = 'jobInvoiceIcon';

ContextMenuIconName.invoice = 'invoiceIcon';

ContextMenuIconName.move = 'moveIcon';

ContextMenuIconName.override = 'overrideIcon';

ContextMenuIconName.edit_employee = 'editEmployeeIcon';

ContextMenuIconName.map = 'mapIcon';

ContextMenuIconName.edit_client = 'editClientIcon';

ContextMenuIconName.client = 'clientIcon';

ContextMenuIconName.edit_job_applicant = 'editJobApplicantIcon';

ContextMenuIconName.client_contact = 'clientContactIcon';

ContextMenuIconName.schedule = 'scheduleIcon';

ContextMenuIconName.pay_stub = 'PayStubIcon';

ContextMenuIconName.edit_pay_stub = 'EditPayStubIcon';

ContextMenuIconName.pay_stub_transaction = 'PayStubTransactionIcon';

ContextMenuIconName.pay_stub_transaction_summary = 'PayStubTransactionSummaryIcon';

ContextMenuIconName.pay_stub_summary = 'payStubSummaryIcon';

ContextMenuIconName.edit_pay_period = 'EditPayPeriodIcon';

ContextMenuIconName.edit_pay_period_schedule = 'EditPayPeriodScheduleIcon';

ContextMenuIconName.re_calculate_timesheet = 'ReCalculateTimeSheet';

ContextMenuIconName.re_calculate_accrual = 'ReCalculateAccrual';

ContextMenuIconName.generate_pay_stub = 'GeneratePayStub';

ContextMenuIconName.print = 'printIcon';

ContextMenuIconName.print_timesheet = 'printTimesheetIcon';

ContextMenuIconName.find_available = 'findAvailableIcon';

ContextMenuIconName.authorization = 'authorizationIcon';

ContextMenuIconName.view_print = 'viewPrintIcon';

ContextMenuIconName.view_file = 'viewFileIcon';

ContextMenuIconName.view_form = 'viewFormIcon';

ContextMenuIconName.print_form = 'printFormIcon';

ContextMenuIconName.print_checks = 'printChecksIcon';
ContextMenuIconName.re_order = 'reOrderIcon';

ContextMenuIconName.direct_deposit = 'directDepositIcon';

ContextMenuIconName.employee = 'employeeIcon';
ContextMenuIconName.employee_pay_stubs = 'employeePayStubsIcon';
ContextMenuIconName.employer_pay_stubs = 'employerPayStubsIcon';

ContextMenuIconName.timesheet_view = 'timesheetViewIcon';
ContextMenuIconName.timesheet_view_detail = 'timesheetViewDetailIcon';

ContextMenuIconName.recurring_template = 'recurringTemplateIcon';

ContextMenuIconName.recurring_schedule = 'recurringSchedule';

ContextMenuIconName.save_setup = 'saveSetupIcon';

ContextMenuIconName.e_file = 'eFileIcon';
ContextMenuIconName.e_file_xml = 'eFileXMLIcon';

ContextMenuIconName.request = 'requestIcon';

ContextMenuIconName.exceptions = 'exceptionsIcon';

ContextMenuIconName.timesheet_reports = 'timeSheetReportIcon';

ContextMenuIconName.lock = 'lockIcon';

ContextMenuIconName.unlock = 'unlockIcon';

ContextMenuIconName.transaction = 'transactionIcon';

ContextMenuIconName.pay_stub_amendment = 'payStubAmendmentIcon';

ContextMenuIconName.payroll_export_report = 'payrollExportReportIcon';

ContextMenuIconName.close_pay_period = 'closeIcon';

ContextMenuIconName.payment_method = 'paymentMethodIcon';

ContextMenuIconName.payment = 'PaymentIcon';

ContextMenuIconName.packing_slip = 'PackingSlipIcon';

ContextMenuIconName.migrate_pay_codes = 'MigratePayCodeIcon';

ContextMenuIconName.migrate_pay_stub_account = 'MigratePayStubAccount';

ContextMenuIconName.auto_arrange = 'autoArrange';

ContextMenuIconName.apply_job = 'applyJobIcon';

ContextMenuIconName.job_application = 'jobApplicationIcon';

ContextMenuIconName.portal_preview = 'portalPreviewIcon';
ContextMenuIconName.tax_reports = 'taxReportsIcon';
ContextMenuIconName.preferences = 'preferenceIcon';

ContextMenuIconName.payment_services_statement = 'paymentServicesStatementIcon';

var Icons = function() {

};

Icons.new_add = 'new_add-35x35.png';
Icons.view = 'view-35x35.png';
Icons.edit = 'edit-35x35.png';
Icons.delete_icon = 'delete-35x35.png';
Icons.export_excel = 'export_to_excel-35x35.png';
Icons.export_export = 'export-35x35.png';
Icons.save = 'save-35x35.png';
Icons.move = 'move-35x35.png';
Icons.pass = 'pass-35x35.png';
Icons.cancel = 'cancel-35x35.png';
Icons.companies = 'companies-35x35.png';
Icons.delete_and_next = 'delete_and_next-35x35.png';
Icons.save_and_next = 'save_and_next-35x35.png';
Icons.save_and_new = 'save_and_new-35x35.png';
Icons.save_and_continue = 'save_and_continue-35x35.png';
Icons.save_and_copy = 'save_and_copy-35x35.png';
Icons.copy_as_new = 'copy_as_new-35x35.png';
Icons.copy = 'copy-35x35.png';
Icons.decline = 'decline-35x35.png';
Icons.mass_edit = 'mass_edit-35x35.png';
Icons.view_detail = 'view_detail-35x35.png';
Icons.download = 'download2-35x35.png';
Icons.timesheet = 'timesheet-35x35.png';
Icons.swap = 'swap_shift-35x35.png';
Icons.override = 'override-35x35.png';
Icons.employee = 'employees-35x35.png';
Icons.map = 'map-35x35.png';
Icons.client_contact = 'clients_contacts-35x35.png';
Icons.client = 'clients-35x35.png';
Icons.schedule = 'schedule-35x35.png';
Icons.pay_stubs = 'pay_stubs-35x35.png';
Icons.pay_period = 'pay_periods-35x35.png';
Icons.pay_period_schedule = 'pay_period_schedules-35x35.png';
Icons.send = 'send-35x35.png';
Icons.inbox = 'inbox-35x35.png';
Icons.check_updates = 'about-35x35.png';
Icons.authorization = 'authorize-35x35.png';
Icons.authorization_request = 'authorize_request-35x35.png';
Icons.authorization_timesheet = 'authorize_timesheet-35x35.png';
Icons.authorization_expense = 'approved_expense-35x35.png';
Icons.sent = 'sent-35x35.png';
Icons.close_misc = 'close_misc-35x35.png';
Icons.process_payroll = 'process_payroll-35x35.png';
Icons.map = 'map-35x35.png';
Icons.import_icon = 'import-35x35.png';
Icons.login = 'login-35x35.png';
Icons.permission_wizard = 'permission_groups-35x35.png';
Icons.quick_start_wizard = 'quicksetupwizard-35x35.png';
Icons.re_cal_timesheet = 'calculate-35x35.png';
Icons.re_cal_pay_stub = 'calculate_paystubs-35x35.png';
Icons.hierarchy = 'hierarchy-35x35.png';
Icons.employee_pay_stubs = 'employee_pay_stubs-35x35.png';
Icons.employer_pay_stubs = 'employer_pay_stubs-35x35.png';
Icons.save_setup = 'save_setup-35x35.png';
Icons.e_file = 'export_to_efile-35x35.png';
Icons.recurring_template = 'recurring_template-35x35.png';
Icons.recurring_schedule = 'recurring_schedule-35x35.png';
Icons.request = 'requests-35x35.png';
Icons.exceptions = 'exceptions-35x35.png';
Icons.timesheet_reports = 'timesheet_reports-35x35.png';
Icons.lock = 'lock-35x35.png';
Icons.unlock = 'unlock-35x35.png';
Icons.pay_stub_amendment = 'pay_stub_amendments-35x35.png';
Icons.pay_stub_account = 'pay_stubs_accounts-35x35.png';
Icons.payroll_export_report = 'payroll_reports-35x35.png';
Icons.close = 'close-35x35.png';
Icons.close_pay_period = 'close_pay_period-35x35.png';
Icons.hr_reports = 'hr_reports-35x35.png';
Icons.invoice = 'invoice_wizard-35x35.png';
Icons.transaction = 'transactions-35x35.png';
Icons.payment_method = 'payment_methods-35x35.png';
Icons.packing_slip = 'packing_slip-35x35.png';
Icons.print = 'print-35x35.png';
Icons.in_out = 'clock_in_out-35x35.png';
Icons.find_available = 'fillshift-35x35.png';
Icons.wizard = 'wizard2-35x35.png';
Icons.restart = 'restart-35x35.png';
Icons.branches = 'branches-35x35.png';
Icons.job_applicant = 'job_applicant-35x35.png';
Icons.pay_stub_transaction = 'direct_deposit-35x35.png';
Icons.tax_reports = 'tax_reports-35x35.png';
Icons.preferences = 'preferences-35x35.png';

export { ContextMenuIconName, Icons };
